'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

interface Props {
  children: React.ReactNode;
}

const LayoutComponent = ({ children }: Props) => {
  const pathname = usePathname();
  const isAdminPage = pathname?.startsWith('/admin');

  return (
    <div
      className={`mx-auto h-screen w-screen desktop:overflow-auto overflow-y-scroll scrollbar-hide ${
        isAdminPage ? '' : 'mobile-w'
      }`}
    >
      {children}
    </div>
  );
};

export default LayoutComponent;
